import { NavLink } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { NAV_CONFIG } from "@/lib/navConfig";
import { PREMIUM_FEATURE_TIERS } from "@/lib/premiumFeatures";
import { PremiumBadge } from "@/components/PremiumBadge";
import { BrandWordmark } from "@/components/BrandWordmark";
import { isDemoUser } from "@/lib/demoMode";
import { ROLE_LABELS, initials } from "@/lib/helpers";
import { cn } from "@/lib/utils";
import { Car } from "lucide-react";

export const SidebarNav = ({ onNavigate }) => {
  const { user } = useAuth();
  const items = (NAV_CONFIG[user?.role] || []).filter((i) => !i.adminOnly || user?.role === "admin");
  const showPremiumBadges = isDemoUser(user);

  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center gap-2 px-5 h-16 border-b">
        <div className="h-9 w-9 rounded-xl bg-[hsl(var(--role-accent))] text-white flex items-center justify-center shrink-0">
          <Car className="h-5 w-5" />
        </div>
        <div className="min-w-0">
          <p className="font-heading font-semibold text-sm leading-tight truncate">DriveDesk Hub</p>
          <p className="text-[11px] text-muted-foreground truncate">{ROLE_LABELS[user?.role]}</p>
        </div>
      </div>
      <nav className="flex-1 overflow-y-auto py-3 px-3 space-y-1">
        {items.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === "/"}
            onClick={onNavigate}
            data-testid={`nav-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
            className={({ isActive }) =>
              cn(
                "flex items-center gap-3 rounded-[var(--radius)] px-3 py-2.5 text-sm font-medium min-h-11 transition-colors",
                isActive
                  ? "bg-[hsl(var(--role-accent))]/10 text-[hsl(var(--role-accent))]"
                  : "text-foreground/80 hover:bg-accent hover:text-accent-foreground"
              )
            }
          >
            <item.icon className="h-[18px] w-[18px] shrink-0" />
            <span className="truncate flex-1">{item.label}</span>
            {showPremiumBadges && <PremiumBadge tier={PREMIUM_FEATURE_TIERS[item.label]} />}
          </NavLink>
        ))}
      </nav>
      <div className="p-4 border-t space-y-3">
        <div className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-full bg-secondary flex items-center justify-center text-xs font-semibold">
            {initials(user?.full_name)}
          </div>
          <div className="min-w-0">
            <p className="text-sm font-medium truncate">{user?.full_name}</p>
            <p className="text-xs text-muted-foreground truncate">{user?.email}</p>
          </div>
        </div>
        <BrandWordmark />
      </div>
    </div>
  );
};
